export default __webpack_public_path__ + "static/media/logo.f23f9e79.svg";